import BaseApiClient from '../BaseApiClient';
import { PriorityInterface } from '@interfaces/Priority.interface';
import { SelectOptionsResolver } from '@ui/SelectField/types';

export class ApiPriority extends BaseApiClient {
  /**
   * Get all items
   */
  async all(): Promise<Array<PriorityInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/priority?page[size]=999&sort=id')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  optionsResolver: SelectOptionsResolver = async () => {
    const items = await this.all();
    return items
      ? items.map((i) => ({ value: `${i.id}`, label: i.name }))
      : null;
  };
}

export { priorityQueryKeys } from './query-keys';
export { usePriorityAllQuery } from './use-priority-queries';
